import { handleActions } from 'redux-actions';
import { formValueSelector, getFormValues, arrayRemove, arrayPush } from 'redux-form';
import endpoints from '../../config/endpoints';
import http from '../shared/http';
import intl from '../shared/intl';
import { LOCATION_CHANGE, replace } from 'react-router-redux';
import { baseUrl } from '../../config/route-entry-point';
import { SubmissionError } from 'redux-form';
import qs from 'qs';
import csv from 'csv-stringify';

import cloneDeep from 'lodash/cloneDeep';
import isEmpty from 'lodash/isEmpty';
import _mapValues from 'lodash/mapValues';
import _stubFalse from 'lodash/stubFalse';
import _keys from 'lodash/keys';
import _omit from 'lodash/omit';
import _get from 'lodash/get';
import _reject from 'lodash/reject';
import _times from 'lodash/times';
import _pick from 'lodash/pick';
import _capitalize from 'lodash/capitalize';
import _stubString from 'lodash/stubString';
import createCalendar from '../shared/calendar';
import createFilters from '../shared/filters';

import { REFETCH_ALL_DATA } from '../root';
import createArrayFieldErrors from './shared/createArrayFieldErrors';

import { enum as postbackLogTypes } from '../../../../enums/postback-log-types';
import { enum as postbackTypes } from '../../../../enums/postback-types';
import moment from 'moment';

// action types
const FETCH_DATA_SUCCESS = 'global-postback/fetch-data-success';
const FETCH_DATA_ERROR = 'global-postback/fetch-data-error';

const SAVE_FORM_DATA_SUCCESS = 'global-postback/save-form-data-success';
const SAVE_FORM_DATA_ERROR = 'global-postback/save-form-data-error';

const FORM_CHECKED_CHECKBOX = 'global-postback/checked-checkbox';
const FORM_CHANGE_URL = 'global-postback/change-url';
const FORM_ADD_FIELD = 'global-postback/add-field';
const FORM_REMOVE_FIELD = 'global-postback/remove-field';
const CHANGE_TYPE_ERRORS = 'global-postback/change-type-errors';
const FETCH_PAGE_SUCCESS = 'global-postback/fetch-page-success';
const FETCH_PAGE_ERROR = 'global-postback/fetch-page-error';

const FETCH_POSTBACKS_SUCCESS = 'global-postback/fetch-postbacks-success';
const FETCH_DOWNLOAD_POSTBACKS_SUCCESS = 'global-postback/fetch-download-postbacks-success';

const TOGGLE_PROGRESS_BAR = 'global-postback/toggle-progress-bar';

const FETCH_RESEND_LOOKUPS = 'global-postback/fetch-redend-lookups';
const FETCH_RESEND_LOOKUPS_SUCCESS = 'global-postback/fetch-redend-lookups-success';
const FETCH_RESEND_LOOKUPS_ERROR = 'global-postback/fetch-redend-lookups-error';
const FETCH_RESEND_POSTBACKS_SUCCESS = 'global-postback/fetch-redend-postback-success';
const FETCH_RESEND_POSTBACKS_ERROR = 'global-postback/fetch-redend-postback-error';
const RESEND_POSTBACKS_SUCCESS = 'global-postback/resend-postback-success';
const RESEND_POSTBACKS_ERROR = 'global-postback/resend-postback-error';

const isRocket = process.env.CPA_ENV === 'rocket';

const FIELDS_LIMIT = isRocket ? 3 : 2;
const LOGS_LIMIT = 8;
const DOWNLOAD_LIMIT = 10000;

const calendarResendPostback = createCalendar({
	namespace: 'globalPostback',
	stateNodeName: 'calendarResendPostback',
	defaultValue: {
		start: moment().subtract(14, 'days').format('YYYY-MM-DD'),
		end: moment().format('YYYY-MM-DD')
	}
});
const calendarPostbackList = createCalendar({
	namespace: 'globalPostback',
	stateNodeName: 'calendarPostbackList',
	defaultValue: {
		start: moment().subtract(14, 'days').format('YYYY-MM-DDTHH:mm:ss.SSSZ'),
		end: moment().format('YYYY-MM-DDTHH:mm:ss.SSSZ')
	}
});

const postbackFilters = createFilters({
	namespace: 'globalPostback',
	stateNodeName: 'filters',
	filtersInitialState: [{
		title: 'Оффер',
		suggest: [{
			placeholder: 'Выберите оффер',
			key: 'offer_ids',
			options: {
				source: endpoints.LOOKUPS.OFFERS,
				type: 'fromServer'
			}
		}]
	}, {
		title: 'Поток',
		suggest: [{
			placeholder: 'Выберите поток',
			key: 'campaign_ids',
			options: {
				source: endpoints.LOOKUPS.STREAMS,
				type: 'fromServer'
			}
		}]
	}, {
		title: 'SubID',
		suggest: [
			{
				placeholder: 'SID1',
				key: 'sid1',
				options: {
					source: endpoints.STATISTICS.FILTERS.SID1,
					type: 'fromServer'
				}
			},
			{
				placeholder: 'SID2',
				key: 'sid2',
				options: {
					source: endpoints.STATISTICS.FILTERS.SID2,
					type: 'fromServer'
				}
			},
			{
				placeholder: 'SID3',
				key: 'sid3',
				options: {
					source: endpoints.STATISTICS.FILTERS.SID3,
					type: 'fromServer'
				}
			},
			{
				placeholder: 'SID4',
				key: 'sid4',
				options: {
					source: endpoints.STATISTICS.FILTERS.SID4,
					type: 'fromServer'
				}
			},
			{
				placeholder: 'SID5',
				key: 'sid5',
				options: {
					source: endpoints.STATISTICS.FILTERS.SID5,
					type: 'fromServer'
				}
			}
		]
	}]
});

const headersConfig = [{
	id: 'date',
	title: 'date'
}, {
	id: 'campaign',
	title: 'campaign'
}, {
	id: 'url',
	title: 'url'
}, {
	id: 'status',
	title: 'status'
}];

// initialState state
const initialState = {
	data: null,
	error: null,
	showProgressBar: false,
	settingsFormData: null,
	validate: {},
	postbackTypeErrors: _times(FIELDS_LIMIT, _stubString),
	fieldsLimit: FIELDS_LIMIT,
	offset: 0,
	calendarResendPostback: calendarResendPostback.initialState,
	resendPostbacksLeft: 0,
	resendPostbacksTotal: 0,
	resendPostbacksLookups: {
		campaignes: [],
		conversions: []
	},
	showMoreLogsButton: true,
	filters: postbackFilters.initialState,
	calendarPostbackList: calendarPostbackList.initialState,
	query: {}
};

const postbackMapping = {
	postback_send_status: postbackTypes.status,
	postback_only_approved: postbackTypes.approve,
	postback_only_pending: postbackTypes.pending,
	postback_only_rejected: postbackTypes.rejected,
	postback_only_trash: postbackTypes.trash
};

const convertToPostback = ({
	global_postback_ignore_trash,
	global_postback_type,
	postback_send_payout_for_approved_only,
	global_postback_config,
	global_postback_url
}) => {
	const initial_postback_config = global_postback_config || {};
	const postback_types = initial_postback_config.postback_types || [ global_postback_type ];

	return {
		postback_send_status: postback_types.includes(postbackTypes.status),
		postback_ignore_trash: global_postback_ignore_trash,
		postback_send_payout_for_approved_only: !!postback_send_payout_for_approved_only,
		postback_only_approved: postback_types.includes(postbackTypes.approve),
		postback_only_pending: postback_types.includes(postbackTypes.pending),
		postback_only_rejected: postback_types.includes(postbackTypes.rejected),
		postback_only_trash: postback_types.includes(postbackTypes.trash),
		postback_ignore_restricted: !!initial_postback_config.postback_ignore_restricted,
		postback_on_payout_change: !!initial_postback_config.postback_on_payout_change,
		global_postback_url: global_postback_url
	};
};

const createPostbacksArray = postback => {
	const generalPostback = [_omit(postback, ['additional_postbacks'])];
	const additionalPostbacks = _get(postback, ['additional_postbacks'], []);
	return generalPostback
		.concat(additionalPostbacks)
		.map(convertToPostback);
};

const checkboxDisabledStatus = ({
	postback_only_approved,
	postback_send_status,
	postback_only_pending,
	postback_only_rejected,
	postback_only_trash,
	postback_ignore_trash
}) => {
	const disabled = {
		postback_send_status: true,
		postback_only_approved: true,
		postback_only_rejected: true,
		postback_only_trash: true,
		postback_ignore_trash: true,
		postback_only_pending: true
	};
	switch (true) {
		case postback_only_approved:
		case postback_only_pending:
		case postback_only_rejected:
		case postback_only_trash:
			return {
				...disabled, postback_only_approved: false, postback_only_pending: false,
				postback_only_rejected: false, postback_only_trash: false
			};
		case postback_ignore_trash:
		case postback_send_status:
			return { ...disabled, postback_ignore_trash: false, postback_send_status: false };
		default:
			return { ..._mapValues(disabled, _stubFalse), postback_ignore_trash: true };
	}
};

const setDisabled = postbacks => postbacks.map(checkboxDisabledStatus);

const extractPostbacks = postbacks => postbacks.map(field => {
	const postback_types = [];
	const fieldsWithoutPostbackType = [
		'global_postback_url', 'postback_ignore_trash', 'postback_send_payout_for_approved_only',
		'postback_ignore_restricted', 'postback_on_payout_change'
	];
	_keys(_omit(field, fieldsWithoutPostbackType))
		.forEach(key => {
			if (field[key]) postback_types.push(postbackMapping[key]);
		});
	return {
		global_postback_type: null,
		postback_send_payout_for_approved_only: field.postback_send_payout_for_approved_only,
		global_postback_url: !isEmpty(field.global_postback_url)
			? field.global_postback_url : null,
		global_postback_config: {
			postback_ignore_restricted: !!field.postback_ignore_restricted,
			postback_on_payout_change: !!field.postback_on_payout_change,
			postback_types
		},
		global_postback_ignore_trash: !!field.postback_ignore_trash
	};
});

// actions
export const actions = {

	fetchData: () => (dispatch, getState) => {

		dispatch({ type: TOGGLE_PROGRESS_BAR });

		http({
			url: [
				endpoints.PROFILE.GLOBAL_POSTBACK,
				`${endpoints.LISTS.POSTBACK_LOG}/${postbackLogTypes.global}?${
					qs.stringify({ limit: LOGS_LIMIT, offset: 0 })
				}`
			],
			method: 'get',
			actions: [
				FETCH_DATA_SUCCESS,
				FETCH_DATA_ERROR
			]
		})(dispatch)
			.then(() => {
				if (getActiveTab() === 'resend')
					return actions.getResendPostbackUrls()(dispatch, getState);
			})
			.then(() => dispatch({ type: TOGGLE_PROGRESS_BAR }));
	},
	resendPostbackUrls: query => (dispatch, getState) => {
		return http({
			url: 	`${endpoints.PROFILE.RESEND_POSTBACK}?${qs.stringify(query)}`,
			method: 'post',
			actions: [ RESEND_POSTBACKS_SUCCESS, RESEND_POSTBACKS_ERROR ]
		})(dispatch)
			.then(() => {
				const interval = setInterval(() => {
					actions.getResendPostbackUrls()(dispatch, getState);
					if (selectors.getResendPostbacksLeft(getState()) <= 0)
						clearInterval(interval);
				}, 5000);
			});
	},
	resendNewPostbackUrls: () => (dispatch, getState) => {
		const query = selectors.getPostbackResendFilter(getState(), {isOldUrlPostback: false});
		return actions.resendPostbackUrls(query)(dispatch, getState);
	},
	resendOldPostbackUrls: () => (dispatch, getState) => {
		const query = selectors.getPostbackResendFilter(getState(), {isOldUrlPostback: true});
		return actions.resendPostbackUrls(query)(dispatch, getState);
	},

	getResendPostbackUrls: () => (dispatch, getState) => {
		const query = selectors.getPostbackResendFilter(getState(), {isOldUrlPostback: true});
		http({
			url: 	`${endpoints.PROFILE.RESEND_POSTBACK}?${qs.stringify(query)}`,
			method: 'get',
			actions: [ FETCH_RESEND_POSTBACKS_SUCCESS, FETCH_RESEND_POSTBACKS_ERROR ]
		})(dispatch);
	},

	formSaveData: formData =>  dispatch => {
		const [general, ...additional_postbacks] = extractPostbacks(formData.postbacks);

		const request = http({
			url: endpoints.PROFILE.GLOBAL_POSTBACK,
			method: 'put',
			actions: [
				SAVE_FORM_DATA_SUCCESS,
				SAVE_FORM_DATA_ERROR
			],
			data: {
				...general,
				additional_postbacks
			}
		});

		return request(dispatch).then(action => {
			const { type, payload } = action;
			if (type === SAVE_FORM_DATA_SUCCESS && !payload.data.errors) {
				dispatch(replace(baseUrl('campaigns/')));
				dispatch({type: REFETCH_ALL_DATA});
			}

			if (type === SAVE_FORM_DATA_ERROR && payload.response.status === 400) {
				const responseErrors = action.payload.response.data;
				const errors = createArrayFieldErrors(responseErrors, FIELDS_LIMIT);
				const postbackTypeErrors = errors.map(error => error.global_postback_type
					? _capitalize(error.global_postback_type)
					: '');
				dispatch({
					type: CHANGE_TYPE_ERRORS,
					payload: postbackTypeErrors
				});

				throw new SubmissionError({
					postbacks: errors
				});
			}
		});
	},

	checked: (fieldName, value, idx) => (dispatch, getState) => {
		dispatch({
			type: CHANGE_TYPE_ERRORS,
			payload: _times(FIELDS_LIMIT, _stubFalse)
		});
		dispatch({
			type: FORM_CHECKED_CHECKBOX,
			payload: {
				idx,
				field: fieldName,
				checkboxNewValue: value === 'false', //inverse old value, value === typeof('string')
				postbackUrl: formValueSelector('globalPostbackForm')(getState(), `postbacks[${idx}]global_postback_url`)
			}
		});
	},

	changeUrl: (value, idx) => dispatch => {
		dispatch({
			type: CHANGE_TYPE_ERRORS,
			payload: _times(FIELDS_LIMIT, _stubFalse)
		});
		dispatch({
			type: FORM_CHANGE_URL,
			payload: { idx, value }
		});
	},
	fetchPostbacks: (e) => (dispatch, getState) => {
		e.preventDefault();
		const filters = getPostbackFilters(getState());

		const url = `${endpoints.LISTS.POSTBACK_LOG}/${postbackLogTypes.global}?
			${qs.stringify({ limit: LOGS_LIMIT, offset: 0, filters })}`;

		dispatch({ type: TOGGLE_PROGRESS_BAR });
		const request = http({
			url,
			method:'get',
			actions: [ FETCH_POSTBACKS_SUCCESS ]
		});

		return request(dispatch).then(() => dispatch({ type: TOGGLE_PROGRESS_BAR }));
	},
	downloadPostbacks: (e) => (dispatch, getState) => {
		e.preventDefault();
		const filters = getPostbackFilters(getState());
		const url = `${endpoints.LISTS.POSTBACK_LOG}/${postbackLogTypes.global}?
			${qs.stringify({ limit: DOWNLOAD_LIMIT, offset: 0, filters })}`;

		return http({
			url,
			method:'get',
			actions: [ FETCH_DOWNLOAD_POSTBACKS_SUCCESS ]
		})(dispatch)
			.then(action => {
				if (action.type === FETCH_DOWNLOAD_POSTBACKS_SUCCESS) {
					const postbackLog = action.payload.data
						.map(pl => ({...pl, campaign: `${pl.campaign}(${pl.offer})`}));

					const rows = [].concat(
						[headersConfig.map(hc => hc.title)],
						postbackLog.map(pl => Object.values(_pick(pl, ['date', 'campaign', 'url', 'status'])))
					);
					createCsvFromArray(rows);
				}

			});

	},
	fetchResendPostbackLookup:  () => (dispatch, getState) => {
		const query = qs.stringify(selectors.getPostbackResendFilter(getState())) ;
		const request = http({
			url: [
				endpoints.LOOKUPS.STREAMS,
				`${endpoints.LOOKUPS.POSTBACK_CONVERSIONS}?${query}`
			],
			method: 'get',
			actions: [FETCH_RESEND_LOOKUPS_SUCCESS, FETCH_RESEND_LOOKUPS_ERROR]
		});

		return request(dispatch)
			.then((result) => {
				const [ streams, conversions] = result.payload.map(i => i.data);
				result.type === FETCH_RESEND_LOOKUPS_SUCCESS &&
					dispatch({
						type: FETCH_RESEND_LOOKUPS,
						payload: [
							streams.map(str => ({label: str.text, value: str.id})),
							conversions.map(str => ({label: str.text, value: str.id}))
						]
					});
			})
			.then(() => {
				return actions.getResendPostbackUrls()(dispatch, getState);
			});
	},

	addField: e => dispatch => {
		e.stopPropagation();
		e.preventDefault();
		const placeholder = {
			global_postback_url: '',
			postback_ignore_trash: false,
			postback_only_approved: false,
			postback_send_payout_for_approved_only: false,
			postback_only_pending: false,
			postback_send_status: false
		};
		dispatch(arrayPush('globalPostbackForm', 'postbacks', placeholder));
		dispatch({
			type: CHANGE_TYPE_ERRORS,
			payload: _times(FIELDS_LIMIT, _stubFalse)
		});
		dispatch({
			type: FORM_ADD_FIELD,
			payload: placeholder
		});
	},

	removeField: (e, idx) => dispatch => {
		e.stopPropagation();
		e.preventDefault();
		dispatch(arrayRemove('globalPostbackForm', 'postbacks', idx));
		dispatch({
			type: CHANGE_TYPE_ERRORS,
			payload: _times(FIELDS_LIMIT, _stubFalse)
		});
		dispatch({
			type: FORM_REMOVE_FIELD,
			payload: idx
		});
	},

	// show more
	showMore: () => (dispatch, getState) => {
		const { offset } = getState().globalPostback;
		http({
			url: `${endpoints.LISTS.POSTBACK_LOG}/${postbackLogTypes.global}?${qs.stringify({
				limit: LOGS_LIMIT,
				filters: getPostbackFilters(getState()),
				offset: Number(offset) + LOGS_LIMIT
			})}`,
			method: 'get',
			actions: [
				FETCH_PAGE_SUCCESS,
				FETCH_PAGE_ERROR
			],
			addToResponse: offset + LOGS_LIMIT
		})(dispatch);
	},
	...calendarResendPostback.actions,
	...postbackFilters.actions,
	...calendarPostbackList.actions
};

// reducers
const reducers = Object.assign({
	[LOCATION_CHANGE]: (state, action) => {
		return initialState;
	},

	[FETCH_DATA_SUCCESS]: (state, action) => {
		const [ postbackSettings, postbackLogs ] = action.payload.map(res => res.data);
		return {
			...state,
			data: postbackLogs,
			settingsFormData: createPostbacksArray(postbackSettings),
			showMoreLogsButton: postbackLogs.length >= FIELDS_LIMIT
		};
	},

	[FETCH_PAGE_SUCCESS]: (state, action) => ({
		...state,
		data: state.data.concat(action.payload.data),
		offset: action.meta,
		showMoreLogsButton: action.payload.data.length >= LOGS_LIMIT
	}),
	[FETCH_POSTBACKS_SUCCESS]: (state, action) => {
		const postbacklog = action.payload.data &&
			action.payload.data.map(postback => {
				postback.date = postback.date.replace('Z', '');
				return postback;
			});

		return {
			...state,
			data: postbacklog,
			offset: 0,
			showMoreLogsButton: action.payload.data.length >= LOGS_LIMIT
		};
	},
	[FETCH_PAGE_ERROR]: state => ({ ...state, error: true }),

	[FETCH_DATA_ERROR]: state => {
		return { ...state, error: true };
	},

	[FORM_CHANGE_URL]: (state, action) => {
		const { idx, value } = action.payload;

		return {
			...state,
			settingsFormData: [
				...state.settingsFormData.slice(0, idx),
				{ ...state.settingsFormData[idx], global_postback_url: value },
				...state.settingsFormData.slice(idx + 1)
			]
		};
	},

	[FORM_CHECKED_CHECKBOX]: (state, action) => {
		const { idx, field, checkboxNewValue, postbackUrl } = action.payload;
		const fields = {
			[field]: checkboxNewValue,
			global_postback_url: postbackUrl
		};

		if (fields.postback_send_status === false) {
			fields.postback_ignore_trash = false;
		}
		if (fields.postback_only_pending) {
			fields.postback_send_payout_for_approved_only = false;
		}

		return {
			...state,
			settingsFormData: [
				...state.settingsFormData.slice(0, idx),
				{ ...state.settingsFormData[idx], ...fields },
				...state.settingsFormData.slice(idx + 1)
			]
		};
	},

	[FORM_ADD_FIELD]: (state, action) => ({
		...state,
		settingsFormData: state.settingsFormData.concat([action.payload])
	}),

	[TOGGLE_PROGRESS_BAR]: state => ({
		...state,
		showProgressBar: !state.showProgressBar
	}),

	[FETCH_RESEND_POSTBACKS_SUCCESS]: (state, action) => ({
		...state,
		resendPostbacksLeft: action.payload.data.remainingResend || 0,
		resendPostbacksTotal: action.payload.data.totalPostbacks || 0
	}),

	[RESEND_POSTBACKS_SUCCESS]: (state, action) => ({
		...state,
		resendPostbacksLeft: action.payload.data.remainingResend || 0
	}),

	[CHANGE_TYPE_ERRORS]: (state, action) => ({
		...state,
		postbackTypeErrors: action.payload
	}),

	[FETCH_RESEND_LOOKUPS]: (state, action) => {
		const [campaignes, conversions] = action.payload;
		return  {
			...state,
			resendPostbacksLookups: {
				...state.resendPostbacksLookups,
				campaignes,
				conversions
			}
		};
	},

	[FORM_REMOVE_FIELD]: (state, action) => ({
		...state,
		settingsFormData: _reject(state.settingsFormData, (item, id) => id === action.payload)
	}),

	[SAVE_FORM_DATA_SUCCESS]: (state, action) => {
		if (action.payload.data && action.payload.data.errors) {
			return { ...state, validate: action.payload.data.errors};
		}
		return { ...state };
	},
	[REFETCH_ALL_DATA]: () => initialState
},
calendarResendPostback.reducers,
calendarPostbackList.reducers,
postbackFilters.reducers
);

export default handleActions(reducers, cloneDeep(initialState));

// selectors
export const selectors = {
	getData: state => state.globalPostback.data,
	getResendPostbacksLeft: state => state.globalPostback.resendPostbacksLeft,
	getProgressBar: state => state.globalPostback.showProgressBar,
	getResendPostbacksTotal: state => state.globalPostback.resendPostbacksTotal,
	getAffiliateId: state => _get(state, 'app.userData.general.affiliate_id', 0),
	getFormSettings: state => ({
		data: state.globalPostback.settingsFormData || [],
		checkboxDisabledStatus: state.globalPostback.settingsFormData
			&& setDisabled(state.globalPostback.settingsFormData),
		errors: state.globalPostback.validate || null
	}),
	getPostbackTypeErrors: state => state.globalPostback.postbackTypeErrors,
	getLogTable: state => ({
		tableRows: state.globalPostback.data && sliceRows(state.globalPostback.data, state.globalPostback.logNumberRows),
		showMoreLogsButton: state.globalPostback.showMoreLogsButton
	}),
	getFieldsLimit: state => state.globalPostback.fieldsLimit,
	getError: state => state.globalPostback.error,
	getFilters: state => postbackFilters.selectors.selectFilters(
		state => state.globalPostback.filters, state => state
	)(state),
	getAppliedFilters: state => postbackFilters.selectors.appliedFilters(state),
	getResendLookups: state => state.globalPostback.resendPostbacksLookups,
	getCalendar: state => calendarResendPostback.selectors.getCalendar(
		state => state.globalPostback.calendarResendPostback,
		state => state
	)(state),
	getListCalendar: state => calendarResendPostback.selectors.getCalendar(
		state => state.globalPostback.calendarPostbackList,
		state => state
	)(state),
	getPostbackListCalendar: state => calendarPostbackList.selectors.getCalendar(
		state => state.globalPostback.calendarPostbackList,
		state => state
	)(state),
	getPostbackResendFilter: (state, params = {isOldUrlPostback: false}) => {
		const filters = getFormValues('postbackResendFilter')(state);

		const { start, end }= state.globalPostback.calendarResendPostback.value;
		const filtersValues = {
			dates: [
				moment(start).startOf('day').format('YYYY-MM-DD HH:mm:ss.SSS'),
				moment(end).endOf('day').format('YYYY-MM-DD HH:mm:ss.SSS')
			]
		};
		filtersValues.is_old_url_postback = params.isOldUrlPostback || null;

		if (!filters) return filtersValues;
		_keys(filters).forEach(key => {filtersValues[key] = filters[key].map(i => i.value);});
		return filtersValues;
	},
	getIntl: state => intl(state)
};

const sliceRows = (rows, rowsNumber) => rows.slice(0, rowsNumber);

function getPostbackFilters(state) {
	const filters = {};

	const appliedFilters = selectors.getAppliedFilters(state);
	appliedFilters.forEach(fltr => filters[fltr.suggestId]
		? (filters[fltr.suggestId].push(fltr.itemId))
		: (filters[fltr.suggestId] = [fltr.itemId])
	);

	const sidFilters = _get(state, 'globalPostback.filters.2.suggest', {});
	['sid1', 'sid2', 'sid3', 'sid4', 'sid5'].forEach(sd => {
		const sidValue = _get(sidFilters, `${sd}.suggestQuery`);

		if (sidValue) {
			filters[sd] = sidValue;
		}
	});

	let {start, end} = selectors.getListCalendar(state).value;
	start = moment(start).hours(0).minutes(0).seconds(0).milliseconds(0);
	end = moment(end).hours(23).minutes(59).seconds(59).milliseconds(999);

	filters['date_range'] = {
		start: start.format('YYYY-MM-DDTHH:mm:ss.SSSZ'),
		end: end.format('YYYY-MM-DDTHH:mm:ss.SSSZ')
	};

	return filters;
}
function createCsvFromArray(rows) {
	return csv(rows, (err, res) => {
		const exportFilename = `Export--Postbacks--${moment().format(
			'YYYY-MM-DD--HH-mm-ss'
		)}.csv`;
		const csvData = new Blob([res], { type: 'text/csv;charset=utf-8;' });
		//IE11 & Edge
		if (navigator.msSaveBlob) {
			navigator.msSaveBlob(csvData, exportFilename);
		} else {
			//In FF link must be added to DOM to be clicked
			const link = document.createElement('a');
			link.href = window.URL.createObjectURL(csvData);
			link.setAttribute('download', exportFilename);
			document.body.appendChild(link);
			link.click();
			document.body.removeChild(link);
		}
	});
}

function getActiveTab() {
	const { pathname } = window.location;
	return pathname
		.replace('campaigns/global-postback', '')
		.replaceAll('/', '');
}


// WEBPACK FOOTER //
// ./frontend/cabinets/modules/global-postback/index.js